import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import Checkbox from '../checkbox/Checkbox';
import Button from '../button/Button';
import * as classes from './SmeLendingForm.module.scss';
import Table, { TableBody, TableCell, TableHeading, TableRow } from '../table/Table';

function Row({ dayName, register }) {
  const lowerDayName = dayName.toLowerCase();
  return (
    <TableRow>
      <TableCell fill strong as="th">
        {dayName}
      </TableCell>
      <TableCell>
        <Checkbox
          id={`availability__${lowerDayName}_morning`}
          className={classes.availability}
          {...register(`${lowerDayName}Hours`)}
          value="morning"
          label={`${dayName} morning, 9AM to 12PM`}
          hideLabel
        />
      </TableCell>
      <TableCell>
        <Checkbox
          id={`availability__${lowerDayName}_early_afternoon`}
          className={classes.availability}
          {...register(`${lowerDayName}Hours`)}
          value="early_afternoon"
          label={`${dayName} early afternoon, 12PM to 2PM`}
          hideLabel
        />
      </TableCell>
      <TableCell>
        <Checkbox
          id={`availability__${lowerDayName}_late_afternoon`}
          className={classes.availability}
          {...register(`${lowerDayName}Hours`)}
          value="late_afternoon"
          label={`${dayName} late afternoon, 2PM to 5PM`}
          hideLabel
        />
      </TableCell>
    </TableRow>
  );
}

function Step6({ onSubmit }) {
  const { handleSubmit, register } = useForm({
    mode: 'onTouched'
  });

  return (
    <form
      className={classes.step}
      onSubmit={handleSubmit((data) => {
        const contactAvailability = Object.keys(data).reduce(
          (obj, key) => {
            const selectedTimes = data[key] || [];

            if (selectedTimes.includes('morning')) {
              obj.availabilityHours[key].push(9, 10, 11);
            }

            if (selectedTimes.includes('early_afternoon')) {
              obj.availabilityHours[key].push(12, 13);
            }

            if (selectedTimes.includes('late_afternoon')) {
              obj.availabilityHours[key].push(14, 15, 16);
            }

            return obj;
          },
          {
            availabilityHours: {
              mondayHours: [],
              tuesdayHours: [],
              wednesdayHours: [],
              thursdayHours: [],
              fridayHours: []
            }
          }
        );

        return onSubmit(contactAvailability, 7);
      })}
    >
      <p>
        Let us know your preferred contact time in case we need to talk to you about your application. We'll do our best
        to call you at a preferred time.
      </p>
      <Table>
        <TableHeading>
          <TableCell as="th" fill></TableCell>
          <TableCell as="th" fill>
            Morning
            <br />
            (9am - 12pm)
          </TableCell>
          <TableCell as="th" fill>
            Early afternoon
            <br />
            (12pm - 2pm)
          </TableCell>
          <TableCell as="th" fill>
            Late afternoon
            <br />
            (2pm - 5pm)
          </TableCell>
        </TableHeading>
        <TableBody>
          <Row dayName="Monday" register={register} />
          <Row dayName="Tuesday" register={register} />
          <Row dayName="Wednesday" register={register} />
          <Row dayName="Thursday" register={register} />
          <Row dayName="Friday" register={register} />
        </TableBody>
      </Table>
      <Button variant="secondary">Finalise application</Button>
    </form>
  );
}
Step6.propTypes = {
  onSubmit: PropTypes.func
};

export default Step6;
